import vtkGeometryRepresentationProxy from './GeometryRepresentationProxy';
import vtkGlyphRepresentationProxy from './GlyphRepresentationProxy';
import vtkMoleculeRepresentationProxy from './MoleculeRepresentationProxy';
import vtkSkyboxRepresentationProxy from './SkyboxRepresentationProxy';
import vtkSliceRepresentationProxy from './SliceRepresentationProxy';
import vtkSlicedGeometryRepresentationProxy from './SlicedGeometryRepresentationProxy';
import vtkVolumeRepresentationProxy from './VolumeRepresentationProxy';

export default {
  vtkGeometryRepresentationProxy,
  vtkGlyphRepresentationProxy,
  vtkMoleculeRepresentationProxy,
  vtkSkyboxRepresentationProxy,
  vtkSliceRepresentationProxy,
  vtkSlicedGeometryRepresentationProxy,
  vtkVolumeRepresentationProxy,
};
